module.exports = __webpack_public_path__ + "static/media/upload-document-img.307dfe07.jpg";